import { useState, useEffect, useRef } from "react";

const TWENTY_FOUR_HOURS_IN_SECONDS = 24 * 60 * 60;

const calculateRemainingSeconds = (endDate) => {
  if (!endDate) {
    return 0;
  }
  const now = Date.now();
  const end = new Date(endDate).getTime();
  return Math.max(0, Math.floor((end - now) / 1000));
};

const useCountdown = (endDate) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    calculateRemainingSeconds(endDate),
  );

  const showCountdown = remainingSeconds <= TWENTY_FOUR_HOURS_IN_SECONDS;
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!showCountdown) {
      return;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setRemainingSeconds((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [showCountdown]);

  return { remainingSeconds, showCountdown };
};

export default useCountdown;
